import { ActivityEventDto } from '../../../shared/modules/activity/dtos/activity-event.dto';
import { VehicleActivityEventHydration } from './vehicle-activity-event-hydration.dto';

/**
 * A vehicle activity event with hydrated related records.
 */
export class VehicleActivityEventDto extends ActivityEventDto {
  hydrated?: VehicleActivityEventHydration;
}
